import React, { useEffect, useState } from "react";
import api from "../../utilis/api";
import StarRating from "../../components/StarRating";

const Testimonial = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [current, setCurrent] = useState(null);
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    name: "",
    comments: "",
    stars: 5,
  });

  const API = "/testimonial";

  // Fetch testimonials safely
  const fetchTestimonials = async () => {
    try {
      setLoading(true);
      const res = await api.get(API);
      // Ensure we always have an array

      setTestimonials(
        Array.isArray(res.data?.testimonials) ? res.data?.testimonials : [],
      );
    } catch (err) {
      console.error("Failed to fetch testimonials:", err);
      setTestimonials([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTestimonials();
  }, []);

  // Handle input
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // Add testimonial
  const handleAdd = async () => {
    if (!form.name || !form.comments) return alert("Fill all fields");
    try {
      const payload = {
        ...form,
        stars: `${form.stars} Star`
      };
      await api.post(API, payload);
      setIsAddOpen(false);
      setForm({ name: "", comments: "", stars: 5 });
      fetchTestimonials();
    } catch (err) {
      console.error("Add failed:", err);
    }
  };

  // Edit testimonial
  const handleEditClick = (item) => {
    setCurrent(item);
    const starRating = parseInt(item.stars?.split(' ')[0]) || 5;
    setForm({
      name: item.name,
      comments: item.comments,
      stars: starRating
    });
    setIsEditOpen(true);
  };

  const handleUpdate = async () => {
    if (!form.name || !form.comments) return alert("Fill all fields");
    try {
      const payload = {
        ...form,
        stars: `${form.stars} Star`
      };
      await api.put(`${API}/${current._id}`, payload);
      setIsEditOpen(false);
      setForm({ name: "", comments: "", stars: 5 });
      fetchTestimonials();
    } catch (err) {
      console.error("Update failed:", err);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure?")) return;
    try {
      await api.delete(`${API}/${id}`);
      fetchTestimonials();
    } catch (err) {
      console.error("Delete failed:", err);
    }
  };

  return (
    <div className="p-4 md:p-6 bg-black min-h-screen text-white">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-6 gap-3">
        <h2 className="text-xl md:text-2xl font-semibold">Testimonials</h2>
        <button
          onClick={() => setIsAddOpen(true)}
          className="bg-green-600 px-4 py-2 rounded hover:bg-green-700 w-full md:w-auto"
        >
          + Add Testimonial
        </button>
      </div>

      {/* Loading */}
      {loading ? (
        <p className="text-gray-400">Loading...</p>
      ) : testimonials.length === 0 ? (
        <p className="text-gray-400">No testimonials added</p>
      ) : (
        <>
          {/* Desktop Table */}
          <div className="hidden md:block overflow-x-auto border border-gray-700 rounded-lg">
            <table className="min-w-full">
              <thead className="bg-gray-900">
                <tr>
                  <th className="p-3 text-left border-b border-gray-700">#</th>
                  <th className="p-3 text-left border-b border-gray-700">
                    Name
                  </th>
                  <th className="p-3 text-left border-b border-gray-700">
                    Rating
                  </th>
                  <th className="p-3 text-left border-b border-gray-700">
                    Comments
                  </th>
                  <th className="p-3 text-center border-b border-gray-700">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {testimonials.map((item, index) => (
                  <tr key={item._id} className="hover:bg-gray-800">
                    <td className="p-3 border-b border-gray-700">
                      {index + 1}
                    </td>
                    <td className="p-3 border-b border-gray-700">
                      {item.name}
                    </td>
                    <td className="p-3 border-b border-gray-700">
                      <StarRating
                        rating={parseInt(item.stars?.split(' ')[0]) || 5}
                        interactive={false}
                        size={4}
                      />
                    </td>
                    <td className="p-3 border-b border-gray-700">
                      {item.comments.split(" ").slice(0, 10).join(" ")}
                    </td>
                    <td className="p-3 border-b border-gray-700 text-center space-x-2">
                      <button
                        onClick={() => handleEditClick(item)}
                        className="px-3 py-1 bg-blue-600 rounded hover:bg-blue-700"
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => handleDelete(item._id)}
                        className="px-3 py-1 bg-red-600 rounded hover:bg-red-700"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Mobile Cards */}
          <div className="md:hidden space-y-4">
            {testimonials.map((item) => (
              <div
                key={item._id}
                className="bg-gray-900 p-4 rounded border border-gray-700"
              >
                <h3 className="text-lg font-semibold">{item.name}</h3>
                <div className="flex items-center gap-2 mt-2">
                  <StarRating
                    rating={parseInt(item.stars?.split(' ')[0]) || 5}
                    interactive={false}
                    size={4}
                  />
                </div>
                <p className="text-gray-300 mt-2">{item.comments}</p>
                <div className="flex gap-2 mt-4">
                  <button
                    onClick={() => handleEditClick(item)}
                    className="flex-1 bg-blue-600 py-2 rounded"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => handleDelete(item._id)}
                    className="flex-1 bg-red-600 py-2 rounded"
                  >
                    Delete
                  </button>
                </div>
              </div>
            ))}
          </div>
        </>
      )}

      {/* Modal */}
      {(isAddOpen || isEditOpen) && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 px-4">
          <div className="bg-gray-900 w-full max-w-md rounded-lg p-6 border border-gray-700">
            <h3 className="text-xl font-semibold mb-4">
              {isAddOpen ? "Add Testimonial" : "Edit Testimonial"}
            </h3>

            <input
              type="text"
              name="name"
              placeholder="Name"
              value={form.name}
              onChange={handleChange}
              className="w-full mb-3 p-2 rounded bg-black border border-gray-700"
            />

            <textarea
              name="comments"
              placeholder="Comments"
              value={form.comments}
              onChange={handleChange}
              className="w-full mb-4 p-2 rounded bg-black border border-gray-700"
            />

            <div className="mb-4">
              <label className="block text-sm font-medium mb-2">Rating</label>
              <StarRating
                rating={form.stars}
                onRatingChange={(rating) => setForm({ ...form, stars: rating })}
                size={6}
              />
            </div>

            <div className="flex gap-2">
              <button
                onClick={isAddOpen ? handleAdd : handleUpdate}
                className="flex-1 bg-green-600 py-2 rounded hover:bg-green-700"
              >
                {isAddOpen ? "Add" : "Update"}
              </button>
              <button
                onClick={() => {
                  setIsAddOpen(false);
                  setIsEditOpen(false);
                }}
                className="flex-1 bg-gray-700 py-2 rounded"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Testimonial;
